// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sum-rest-input {
    position: relative;
    margin: var(--space-and-half) 0;
}
.sum-rest-input__container {
    display: flex;
    align-items: center;
    gap: 8px;
}

.sum-rest-input__container.disabled {
    opacity: 50%;
    cursor: default;
} 

.sum-rest-input__input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: calc(var(--space-half) + 1px);
    padding: var(--space) var(--space-and-half);
    width: 100%;
    font-family: var(--secondary-font);
    font-size: var(--space);
    max-height: var(--space-x3);
    text-align: center;
}

.sum-rest-input__container.disabled .sum-rest-input__button {
    cursor: default;
}

.sum-rest-input__label {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    color: var(--primary-very-dark-color);
    position: absolute;
    top: calc(var(--space-and-half)* -1);
    left: 0;
    background-color: var(--disabled-sb-bg-color);
    text-align: center;
    width: 100%;
}

.sum-rest-input__button {
    border: 1px solid var(--new-green-color);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--new-green-color);
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/sum-rest-input/SumRestInputComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,4CAA4C;IAC5C,2CAA2C;IAC3C,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,gEAAgE;IAChE,qCAAqC;IACrC,kBAAkB;IAClB,oCAAoC;IACpC,OAAO;IACP,6CAA6C;IAC7C,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;AACtB","sourcesContent":[".sum-rest-input {\n    position: relative;\n    margin: var(--space-and-half) 0;\n}\n.sum-rest-input__container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.sum-rest-input__container.disabled {\n    opacity: 50%;\n    cursor: default;\n} \n\n.sum-rest-input__input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: calc(var(--space-half) + 1px);\n    padding: var(--space) var(--space-and-half);\n    width: 100%;\n    font-family: var(--secondary-font);\n    font-size: var(--space);\n    max-height: var(--space-x3);\n    text-align: center;\n}\n\n.sum-rest-input__container.disabled .sum-rest-input__button {\n    cursor: default;\n}\n\n.sum-rest-input__label {\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    color: var(--primary-very-dark-color);\n    position: absolute;\n    top: calc(var(--space-and-half)* -1);\n    left: 0;\n    background-color: var(--disabled-sb-bg-color);\n    text-align: center;\n    width: 100%;\n}\n\n.sum-rest-input__button {\n    border: 1px solid var(--new-green-color);\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    min-width: 30px;\n    min-height: 30px;\n    aspect-ratio: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    color: var(--new-green-color);\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
